import { render, staticRenderFns } from "./RequestDetailsNew.vue?vue&type=template&id=901cd6aa&scoped=true"
import script from "./RequestDetailsNew.vue?vue&type=script&lang=ts"
export * from "./RequestDetailsNew.vue?vue&type=script&lang=ts"
import style0 from "./RequestDetailsNew.vue?vue&type=style&index=0&id=901cd6aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "901cd6aa",
  null
  
)

export default component.exports